<div class="sw-cms-el-config-moorl-location">
    <sw-cms-mapping-field
        v-model:config="element.config.locationLat"
        value-types="number"
    >
        <mt-number-field
            :label="$tc('sw-cms.elements.moorl-location.label.locationLat')"
            numberType="float"
            step="0.00001"
            digits="5"
            v-model="element.config.locationLat.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.locationLon"
        value-types="number"
    >
        <mt-number-field
            :label="$tc('sw-cms.elements.moorl-location.label.locationLat')"
            numberType="float"
            step="0.00001"
            digits="5"
            v-model="element.config.locationLon.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.marker"
        entity="moorl_marker"
        value-types="entity"
    >
        <sw-entity-single-select
            :label="$tc('sw-cms.elements.moorl-location.label.marker')"
            entity="moorl_marker"
            v-model:value="element.config.markerId.value"
        />
    </sw-cms-mapping-field>
    <mt-text-field
        :label="$tc('sw-cms.elements.moorl-location.label.height')"
        v-model="element.config.height.value"
    />
    <mt-switch
        :label="$tc('sw-cms.elements.moorl-location.label.overrideOsmOptions')"
        v-model="element.config.overrideOsmOptions.value"
    />
    <sw-multi-select
        :label="$tc('sw-cms.elements.moorl-location.label.osmOptions')"
        v-model:value="element.config.osmOptions.value"
        :options="elementOptions.osmOptions"
    />
    <mt-switch
        :label="$tc('sw-cms.elements.moorl-location.label.legend')"
        v-model="element.config.legend.value"
    />
    <template v-if="element.config.legend.value">
        <sw-entity-multi-id-select
            :repository="markerRepository"
            :label="$tc('sw-cms.elements.moorl-location.label.legendItems')"
            v-model:value="element.config.legendItems.value"
        />
        <router-link
            target="_blank"
            rel="noopener"
            :to="{ name: 'moorl.marker.list' }"
        >
            {{ $tc('moorl-marker.title') }}
        </router-link>
    </template>
</div>